/* LLCL Localization DOM hydration v1.0
   Keeps the complete Shopify Markets option set out of the live DOM until
   the customer actually opens a market selector. Exact native form buttons
   are server-rendered inside <template> and cloned synchronously on intent.
*/
(() => {
  'use strict';

  const KEY='__LLCL_LOCALIZATION_DOM_HYDRATE__';
  if(window[KEY]) return;
  window[KEY]=true;

  const ROOT='[data-ll-market-selector]';
  const TRIGGER='[data-ll-market-trigger]';
  const LIST='[data-ll-country-list]';
  const TEMPLATE='[data-ll-country-template]';
  const OPTION='[data-ll-country-option]';

  const hydrate=(market)=>{
    if(!market || market.dataset.llCountriesHydrated==='1') return;

    const list=market.querySelector(LIST);
    const template=market.querySelector(TEMPLATE);
    if(!list) return;

    if(list.querySelector(OPTION)){
      market.dataset.llCountriesHydrated='1';
      template?.remove();
      return;
    }

    if(!template) return;

    list.appendChild(template.content.cloneNode(true));
    template.remove();
    market.dataset.llCountriesHydrated='1';
  };

  document.addEventListener('click',(event)=>{
    const trigger=event.target.closest?.(TRIGGER);
    if(!trigger) return;
    hydrate(trigger.closest(ROOT));
  },true);

  window.LLCLLocalizationDomHydrate={hydrate};
})();